import styles from "../../search-menu.module.scss";
import type { SearchMenuItemViewProps } from "./types-item";

export function SearchMenuItemView({
  visible,
  testId,
  className,
  onClick,
  rest,
  children,
}: SearchMenuItemViewProps) {
  if (!visible) return null;

  return (
    <li role="none">
      <button
        type="button"
        className={[styles.item, className].filter(Boolean).join(" ")}
        data-testid={testId}
        {...rest}
        role="menuitem"
        onClick={onClick}
      >
        {children}
      </button>
    </li>
  );
}
